import React, { useEffect, useState } from "react";
import {
  CustomPagination,
  PageLoader,
  SearchBar,
} from "../../../Components/Components";
import AddQuestionFormModal from "./Modals/AddQuestionFormModal";
import { useDispatch } from "react-redux";
import {
  DeleteQuestionAPI,
  GetQuestionsAPI,
  GetQuestionTypesAPI,
} from "../../Redux/quiz";
import { Dropdown, Table, Tooltip } from "antd";
import { utcToLocalDateTime } from "../../../helpers/utils";
import svg from "../../../Assets/svg";
import ViewQuestionDetailsModal from "./Modals/ViewQuestionDetailsModal";
import { ActionModal } from "../../../Components/Modal/Modal";
import BulkUploadQuestionsModal from "./Modals/BulkUploadQuestionsModal";
import { GetNavbarCounts } from "../../Redux/challenges";

export const AnswerTypes = {
  MultipleChoice: "Multiple Choice",
  TextArea: "Text Area",
};

export const AnswerTypesFilterOptions = [
  {
    label: "Multiple Choice",
    value: "multiple_choice",
  },
  {
    label: "Text Area",
    value: "text",
  },
];

const QuestionBank = () => {
  const dispatch = useDispatch();
  const [searchValue, setSearchValue] = useState("");
  const [debouncedSearchValue, setDebouncedSearchValue] = useState("");

  const [isAddQuestionModalOpen, setIsAddQuestionModalOpen] = useState(false);
  const [idOfQuestionToEdit, setIdOfQuestionToEdit] = useState(null);

  const [viewQuestionModalSettings, setViewQuestionModalSettings] = useState({
    visible: false,
    questionId: null,
  });

  const [isDeletedView, setIsDeletedView] = useState(false);

  const [isBulkUploadModalOpen, setIsBulkUploadModalOpen] = useState(false);

  const [deleting, setDeleting] = useState(false);
  const [idOfQuestionToDelete, setIdOfQuestionToDelete] = useState(null);

  const [fetching, setFetching] = useState(true);
  const [data, setData] = useState([]);
  const [totalCount, setTotalCount] = useState();
  const [page, setPage] = useState(1);
  const limit = 15;

  const pageCount = Math.ceil(totalCount / limit);

  //Filter
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [activeTabKey, setActiveTabKey] = useState("1");
  const [filterSearch, setFilterSearch] = useState("");
  const [questionTypeOptions, setQuestionTypeOptions] = useState([]);
  const [selectedAnswerType, setSelectedAnswerType] = useState([]);
  const [selectedQuestionType, setSelectedQuestionType] = useState([]);
  const [filterCount, setFilterCount] = useState(0);
  const [filterCachedData, setFilterCachedData] = useState(null);

  const fetchQuestions = async () => {
    setFetching(true);
    const result = await dispatch(
      GetQuestionsAPI({
        page: page,
        limit: limit,
        search: debouncedSearchValue,
        questionType: selectedQuestionType,
        answerType: selectedAnswerType,
        isDeletedView: isDeletedView,
      })
    );
    if (result?.success) {
      setTotalCount(result.data.total);
      setData(result.data.data);
    }
    setFetching(false);
  };

  useEffect(() => {
    fetchQuestions();
  }, [page, debouncedSearchValue, isDeletedView]);

  const fetchQuestionTypes = async () => {
    // setFetching(true);
    const result = await dispatch(GetQuestionTypesAPI());
    if (result?.success) {
      setQuestionTypeOptions(result.data.map((i) => ({ value: i, label: i })));
    }
    // setFetching(false);
  };

  useEffect(() => {
    fetchQuestionTypes();
  }, []);

  useEffect(() => {
    if (searchValue === "") {
      setDebouncedSearchValue("");
      return;
    }

    const handler = setTimeout(() => {
      setDebouncedSearchValue(searchValue);
    }, 500);

    return () => clearTimeout(handler);
  }, [searchValue]);

  const deleteQuestionHandler = () => {
    setDeleting(true);
    dispatch(
      DeleteQuestionAPI(
        idOfQuestionToDelete,
        () => {
          setIdOfQuestionToDelete(null);
          setDeleting(false);
          fetchQuestions();
          dispatch(GetNavbarCounts());
        },
        () => {
          setDeleting(false);
        }
      )
    );
  };

  const columns = [
    {
      title: "Question",
      dataIndex: "question",
      key: "question",
      width: "50%",
    },
    {
      title: "Answer Type",
      key: "answer_type",
      width: "15%",
      render: (_, record) => {
        if (record?.ans_type === "text") {
          return <div className="text-green">Text Area</div>;
        } else if (record?.ans_type === "multiple_choice") {
          return <div className="text-orange">Multiple Choice</div>;
        }
      },
    },
    {
      title: "Options",
      key: "options",
      width: "10%",
      render: (_, record) => {
        if (record?.ans_type === "text") {
          return <div>-</div>;
        } else if (record?.ans_type === "multiple_choice") {
          return (
            <div>{record?.options?.length ? record?.options?.length : "-"}</div>
          );
        }
      },
    },
    {
      title: "Created Date",
      key: "date",
      width: "15%",
      render: (_, record) => {
        return (
          <div>
            {record?.created_at ? utcToLocalDateTime(record?.created_at) : "-"}
          </div>
        );
      },
    },
    ...(isDeletedView
      ? []
      : [
          {
            title: "Action",
            key: "action",
            width: "15%",
            render: (_, record) => {
              return (
                <div className="d-flex gap-2">
                  <Tooltip title="View Question Details">
                    <button
                      className={`d-inline-block px-0 py-0`}
                      onClick={(e) => {
                        // navigate(`/admin/quests/details/${record._id}`);
                        setViewQuestionModalSettings({
                          visible: true,
                          questionId: record._id,
                        });
                      }}
                    >
                      {svg?.viewQuestionIcon}
                    </button>
                  </Tooltip>
                  <Tooltip title="Edit Question">
                    <button
                      className={`d-inline-block px-0 py-0`}
                      onClick={(e) => {
                        setIdOfQuestionToEdit(record._id);
                        setIsAddQuestionModalOpen(true);
                      }}
                    >
                      {svg?.editQuestionIcon}
                    </button>
                  </Tooltip>
                  <Tooltip title="Delete Question">
                    <button
                      className={`d-inline-block px-0 py-0`}
                      onClick={(e) => {
                        setIdOfQuestionToDelete(record._id);
                      }}
                    >
                      {svg?.deleteQuestionIcon}
                    </button>
                  </Tooltip>
                </div>
              );
            },
          },
        ]),
  ];

  const refetchDataHandler = () => {
    console.log("refetchDataHandler");
    setPage(1);
    fetchQuestions();
  };

  const handleApplyFilter = () => {
    setFilterCount(selectedAnswerType?.length + selectedQuestionType?.length);
    setFilterCachedData({
      ...filterCachedData,
      selectedAnswerType,
      selectedQuestionType,
    });
    setIsFilterVisible((prev) => !prev);
    refetchDataHandler();
  };

  const menu = (
    <>
      <div className="card filterDropdownCard border-0 rounded-4 shadow overflow-hidden ff">
        <div className="card-body p-0">
          <div className="row gx-0">
            <div className="col-md-4">
              <div className="d-flex flex-column h-100">
                <div className="filter-header border-bottom border-end px-4 py-2">
                  <h5 className="fs-5 fw-semibold text-black mb-0 ff">
                    Filters
                  </h5>
                </div>
                <div className="filter-body border-end p-3 h-100">
                  <ul className="list-unstyled mb-0">
                    <li
                      onClick={() => {
                        setActiveTabKey("1");
                      }}
                    >
                      <div
                        className={`ff btn btn-link filter-tab-link fw-semibold fs-6 text-decoration-none text-start w-100 ${
                          activeTabKey === "1" ? "active" : ""
                        } ${
                          selectedAnswerType?.length > 0
                            ? "active-filter-tab"
                            : ""
                        }
                        `}
                      >
                        Answer Type
                      </div>
                    </li>
                    <li
                      onClick={() => {
                        setActiveTabKey("2");
                      }}
                    >
                      <div
                        className={`ff btn btn-link filter-tab-link fw-semibold fs-6 text-decoration-none text-start w-100 ${
                          activeTabKey === "2" ? "active" : ""
                        } ${
                          selectedQuestionType?.length > 0
                            ? "active-filter-tab"
                            : ""
                        }
                        `}
                      >
                        Question Type
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-6">
              <div className="d-flex flex-column h-100">
                {/* {activeTabKey === "1" && ( */}
                <div className="filter-header border-bottom border-end px-2 py-2">
                  <div className="filter-search position-relative">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search"
                      value={filterSearch}
                      onChange={(e) => setFilterSearch(e?.target?.value)}
                    />
                    <span className="ff svg-14 position-absolute top-50 end-0 translate-middle-y me-3">
                      {svg.search}
                    </span>
                  </div>
                </div>
                {/* )} */}
                <div className="filter-body border-end p-3 h-100">
                  <ul className="list-unstyled mb-0">
                    {activeTabKey === "1" &&
                      AnswerTypesFilterOptions?.filter((elem) =>
                        elem?.label
                          ?.toLowerCase()
                          .includes(filterSearch?.toLowerCase())
                      )?.map((elem) => {
                        return (
                          <li key={elem?._id}>
                            <div className="custom-filter-checkbox mb-2">
                              <input
                                type="checkbox"
                                id={elem?.value}
                                checked={selectedAnswerType?.includes(
                                  elem?.value
                                )}
                                onChange={(e) => {
                                  const isChecked = e?.target?.checked;
                                  if (isChecked) {
                                    setSelectedAnswerType((prev) => [
                                      ...prev,
                                      elem?.value,
                                    ]);
                                  } else {
                                    setSelectedAnswerType((prev) =>
                                      prev?.filter(
                                        (comp) => comp !== elem?.value
                                      )
                                    );
                                  }
                                }}
                              />
                              <label
                                htmlFor={elem?.value}
                                className="ff d-inline-flex align-item-center fs-6 text-black"
                              >
                                <span className="svg-16 me-2">
                                  {svg.filterCheckbox}
                                </span>{" "}
                                {elem?.label}
                              </label>
                            </div>
                          </li>
                        );
                      })}
                    {activeTabKey === "2" &&
                      questionTypeOptions
                        ?.filter((elem) =>
                          elem?.label
                            ?.toLowerCase()
                            .includes(filterSearch?.toLowerCase())
                        )
                        ?.map((elem) => {
                          return (
                            <li key={elem?._id}>
                              <div className="custom-filter-checkbox mb-2">
                                <input
                                  type="checkbox"
                                  id={elem?.value}
                                  checked={selectedQuestionType?.includes(
                                    elem?.value
                                  )}
                                  onChange={(e) => {
                                    const isChecked = e?.target?.checked;
                                    if (isChecked) {
                                      setSelectedQuestionType((prev) => [
                                        ...prev,
                                        elem?.value,
                                      ]);
                                    } else {
                                      setSelectedQuestionType((prev) =>
                                        prev?.filter(
                                          (comp) => comp !== elem?.value
                                        )
                                      );
                                    }
                                  }}
                                />
                                <label
                                  htmlFor={elem?.value}
                                  className="ff d-inline-flex align-item-center fs-6 text-black"
                                >
                                  <span className="svg-16 me-2">
                                    {svg.filterCheckbox}
                                  </span>{" "}
                                  {elem?.label}
                                </label>
                              </div>
                            </li>
                          );
                        })}
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-6">
              <div className="d-flex flex-column h-100">
                <div className="filter-header border-bottom px-2 py-2">
                  <div className="d-flex align-items-center justify-content-between">
                    <p className="ff mb-0 fw-semibold fs-7">
                      Selected (
                      {selectedAnswerType?.length +
                        selectedQuestionType?.length}
                      )
                    </p>
                    <div
                      onClick={() => {
                        setSelectedAnswerType([]);
                        setSelectedQuestionType([]);
                      }}
                      className="text-danger fw-medium fs-7 d-inline-block me-3 cursor-pointer"
                    >
                      Clear All
                    </div>
                  </div>
                </div>
                <div className="filter-body p-3 h-100">
                  <ul className="list-unstyled filterCheckedList mb-0">
                    {selectedAnswerType?.map((elem) => {
                      return (
                        <li key={elem}>
                          <div className="d-flex align-items-center justify-content-between mb-2">
                            <label className="d-inline-flex align-item-center fs-6 text-black">
                              <span className="svg-16 checkedSvg me-2">
                                {svg.filterCheckbox}
                              </span>{" "}
                              {AnswerTypesFilterOptions?.find(
                                (cat) => cat?.value === elem
                              )?.label || ""}
                            </label>
                            <div
                              onClick={() => {
                                setSelectedAnswerType((prev) =>
                                  prev?.filter((comp) => comp !== elem)
                                );
                              }}
                              className="svg-16 d-inline-block"
                            >
                              {svg.filterCrossIcon}
                            </div>
                          </div>
                        </li>
                      );
                    })}
                    {selectedQuestionType?.map((elem) => {
                      return (
                        <li key={elem}>
                          <div className="d-flex align-items-center justify-content-between mb-2">
                            <label className="d-inline-flex align-item-center fs-6 text-black">
                              <span className="svg-16 checkedSvg me-2">
                                {svg.filterCheckbox}
                              </span>{" "}
                              {questionTypeOptions?.find(
                                (cat) => cat?.value === elem
                              )?.label || ""}
                            </label>
                            <div
                              onClick={() => {
                                setSelectedQuestionType((prev) =>
                                  prev?.filter((comp) => comp !== elem)
                                );
                              }}
                              className="svg-16 d-inline-block"
                            >
                              {svg.filterCrossIcon}
                            </div>
                          </div>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="card-footer d-flex justify-content-end align-items-center gap-3 border-top-0 bg-white shadow">
          <div
            // href="#"
            className="fw-medium text-muted fs-6 cursor-pointer"
            onClick={() => {
              setActiveTabKey("1");
              setFilterSearch("");
              setIsFilterVisible(false);
            }}
          >
            Cancel
          </div>
          <button
            className="btn text-white px-3"
            onClick={() => {
              handleApplyFilter();
            }}
            style={{
              backgroundColor: "#E58344",
            }}
          >
            Apply
          </button>
        </div>
      </div>
    </>
  );

  return (
    <>
      <div className="sidenav_content d-flex flex-column justify-content-between ">
        <div className="container-fluid px-4 py-4 h-100">
          <div className="d-flex flex-column h-100 ">
            {isDeletedView && (
              <div
                className="ack_link mb-md-4 mb-2 d-inline-flex align-items-center fw-bold ff fs-6 text-decoration-none txt-orange cursor-pointer gap-2"
                onClick={(e) => {
                  e.preventDefault();
                  setIsDeletedView(false);
                  setPage(1);
                }}
              >
                <span>{svg?.goBack}</span>
                {"Back"}
              </div>
            )}
            <div className="d-flex flex-wrap justify-content-between mb-md-4 mb-3 align-items-center">
              <h2 className="mb-0 fw-bold ff title-color fs-42 mb-2 mb-xl-0">
                {isDeletedView ? "Deleted Questions" : "Question Bank"}{" "}
                {totalCount > 0 && `(${totalCount})`}
              </h2>
              <div className="d-flex flex-md-nowrap flex-wrap align-items-center gap-lg-3 gap-2 ms-auto">
                <SearchBar
                  value={searchValue}
                  setValue={setSearchValue}
                  searchHandler={(e) => setSearchValue(e.target.value)}
                  placeholder={"Search"}
                  inputClass={"border-25 ps-5 ms-auto"}
                  clearData={() => setSearchValue("")}
                />
                <button
                  className="btn btn-primary btn-lg ku-btn btn-50 px-4 ff text-nowrap"
                  onClick={() => {
                    setIsAddQuestionModalOpen(true);
                  }}
                >
                  + Add Question
                </button>
                <button
                  className="btn text-white btn-lg ku-btn btn-50 px-4 ff text-nowrap"
                  style={{
                    backgroundColor: "#E58344",
                  }}
                  onClick={() => {
                    setIsBulkUploadModalOpen(true);
                  }}
                >
                  <div className="d-flex align-items-center gap-2">
                    <span className="svg-22">{svg?.upload}</span> Bulk Upload
                  </div>
                </button>

                <div className="d-flex gap-md-3 gap-2 ms-md-0 ms-auto">
                  <Dropdown
                    overlay={menu}
                    trigger={["click"]}
                    open={isFilterVisible}
                    onOpenChange={(visible) => setIsFilterVisible(visible)}
                    placement="topRight"
                    className="cursor-pointer"
                    overlayClassName="filterDropdown"
                  >
                    <Tooltip title={"Filters"}>
                      <div
                        className="svg-btn svg-50 svg-outline-secondary position-relative cursor-pointer"
                        onClick={() => {
                          setActiveTabKey("1");
                          setIsFilterVisible(true);
                          if (filterCachedData) {
                            setSelectedAnswerType(
                              filterCachedData.selectedAnswerType
                            );
                            setSelectedQuestionType(
                              filterCachedData.selectedQuestionType
                            );
                          }
                        }}
                      >
                        {svg.filterButton}
                        <span className="badge filter-badge position-absolute bg-danger">
                          {filterCount > 0 ? filterCount : ""}
                        </span>
                      </div>
                    </Tooltip>
                  </Dropdown>
                </div>
              </div>
            </div>

            {fetching ? (
              <div className="d-flex justify-content-center align-items-center vh-100">
                <PageLoader />
              </div>
            ) : (
              <>
                <div className="flex-fill overflow-y-auto d-flex flex-column">
                  <div
                    className="table-wrapper"
                    style={{ flex: 1, overflow: "hidden" }}
                  >
                    <Table
                      dataSource={data}
                      className="antTable custom-antd-table"
                      scroll={{ y: "100%", x: 1124 }}
                      pagination={false}
                      columns={columns}
                    />
                  </div>
                </div>
                <CustomPagination
                  className={`mt-3`}
                  pageId={page}
                  setPageId={setPage}
                  pageCount={pageCount}
                  countCalculation={totalCount ? totalCount : 0}
                  limit={limit}
                  deletedText={isDeletedView ? "" : "Deleted Questions"}
                  onDeleteClick={() => {
                    setPage(1);
                    setIsDeletedView(true);
                  }}
                />
              </>
            )}
          </div>
        </div>
      </div>

      {isAddQuestionModalOpen && (
        <AddQuestionFormModal
          isModalOpen={isAddQuestionModalOpen}
          onClose={(refetch = false) => {
            if (refetch) {
              fetchQuestions();
              fetchQuestionTypes();
              dispatch(GetNavbarCounts());
            }
            setIdOfQuestionToEdit(null);
            setIsAddQuestionModalOpen(false);
          }}
          questionId={idOfQuestionToEdit}
        />
      )}

      {viewQuestionModalSettings.visible && (
        <ViewQuestionDetailsModal
          isModalOpen={viewQuestionModalSettings.visible}
          onClose={() =>
            setViewQuestionModalSettings({ visible: false, questionId: "" })
          }
          questionId={viewQuestionModalSettings.questionId}
          onDelete={(id) => {
            setIdOfQuestionToDelete(id);
            setViewQuestionModalSettings({ visible: false, questionId: "" });
          }}
          onEdit={(id) => {
            setIdOfQuestionToEdit(id);
            setIsAddQuestionModalOpen(true);
            setViewQuestionModalSettings({ visible: false, questionId: "" });
          }}
        />
      )}

      {isBulkUploadModalOpen && (
        <BulkUploadQuestionsModal
          isModalOpen={isBulkUploadModalOpen}
          onClose={(refetch = false) => {
            if (refetch) {
              refetchDataHandler();
              dispatch(GetNavbarCounts());
            }
            setIsBulkUploadModalOpen(false);
          }}
        />
      )}

      <ActionModal
        isOpen={idOfQuestionToDelete !== null}
        title="Delete Question, Are You Sure?"
        description={
          "This action will permanently delete the question. Are you sure you want to proceed?"
        }
        buttonText="Yes, Delete"
        isLoading={deleting}
        actionHandler={deleteQuestionHandler}
        cancelHandler={() => setIdOfQuestionToDelete(null)}
      />
    </>
  );
};

export default QuestionBank;
